import { render } from "./MealPreparationGroups-edit.vue?vue&type=template&id=43e91e4d"
import script from "./MealPreparationGroups-edit.vue?vue&type=script&lang=js"
export * from "./MealPreparationGroups-edit.vue?vue&type=script&lang=js"

import "./MealPreparationGroups-edit.vue?vue&type=style&index=0&id=43e91e4d&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__